import React, { useState, useEffect } from 'react'
import { COLOUR_WALK_PALETTE } from '../../utils/colours.js'
import Card from '../../components/Card.jsx'
import * as api from '../../services/api.js'

export default function ColourWalk() {
  const [colState, setColState] = useState({ idx: 0, found: [] })

  useEffect(() => { api.getColourWalk().then(d => { if (d && Object.keys(d).length) setColState(d) }) }, [])

  const colour = COLOUR_WALK_PALETTE[colState.idx % COLOUR_WALK_PALETTE.length]

  function update(next) {
    setColState(next)
    api.saveColourWalk(next)
  }

  function markDay(i) {
    const found = colState.found.includes(i)
      ? colState.found.filter(f => f !== i)
      : [...colState.found, i]
    update({ ...colState, found })
  }

  function nextColour() {
    update({ idx: (colState.idx + 1) % COLOUR_WALK_PALETTE.length, found: [] })
  }

  const count = colState.found.length

  return (
    <Card label="Colour walk" title="Find this colour in the world">
      <div className="colour-header">
        <div className="colour-swatch" style={{ background: colour.hex }} />
        <div>
          <p className="colour-name">{colour.name}</p>
          <p className="colour-prompt">{colour.prompt}</p>
        </div>
      </div>

      <p style={{ fontSize: '0.82rem', color: 'var(--stone)', marginBottom: '0.75rem' }}>
        Click a day when you spot this colour out in the world
      </p>

      <div className="colour-grid">
        {Array.from({ length: 7 }, (_, i) => {
          const found = colState.found.includes(i)
          return (
            <div
              key={i}
              className={`colour-day ${found ? 'found' : ''}`}
              style={{ background: colour.hex, opacity: found ? 1 : 0.25 }}
              onClick={() => markDay(i)}
              title={`Day ${i + 1}`}
            />
          )
        })}
      </div>

      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <button className="save-btn ready" onClick={nextColour} style={{ fontSize: '0.78rem', padding: '6px 14px' }}>
          Next colour
        </button>
        {count > 0 && (
          <span style={{ fontSize: '0.82rem', color: 'var(--sage)', fontStyle: 'italic' }}>
            Spotted {count} time{count > 1 ? 's' : ''} this week
          </span>
        )}
      </div>
    </Card>
  )
}
